import tabsolute from "../assets/images/tabsolute.jpg";
import bandmates from "../assets/images/bandmates.png";
import statcast from "../assets/images/statcast.png";
import algorithms from "../assets/images/algorithms.png";
import fantasy from "../assets/images/fantasy.png";
import rush from "../assets/images/rush.jpg";
import PageLayout from "../components/PageLayout";
import ProjectCard from "../components/ProjectCard";

const projects = [
  {
    href: "https://github.com/jordengerovac/bandmates-app-backend",
    image: bandmates,
    alt: "Bandmates login page",
    title: "Bandmates",
    description:
      "A Spring Boot application backend with JWT authentication, and a React/Redux frontend, that connects musicians and music lovers through their common music taste using the Spotify API.",
    skills: ["Java", "JavaScript", "MySQL", "Spring Boot", "React", "Redux"],
  },
  {
    href: "https://github.com/jordengerovac/python-statcast",
    image: statcast,
    alt: "Homerun hotzone visualization",
    title: "Statcast AI Project",
    description:
      "Displaying Aaron Judge's homerun hot zones using Statcast AI data and python libraries such as matplotlib and pandas.",
    skills: ["Python"],
  },
  {
    href: "https://github.com/jordengerovac/tabsolute-browser-extension",
    image: tabsolute,
    alt: "Tabsolute browser extension dashboard",
    title: "Tabsolute Browser Extension",
    description:
      "A customizable new tab browser extension built with React and Redux. A solution to your boring browser tabs, a user is able to alternate between different views and add a variety of widgets to their view.",
    skills: ["JavaScript", "React", "Redux"],
  },
  {
    href: "https://github.com/jordengerovac/fantasy-helper-app-backend",
    image: fantasy,
    alt: "Fantasy helper iOS app",
    title: "Fantasy Helper App",
    description:
      "Phoenix app with GraphQL and ChatGPT integration, and iOS app, for helping users decide who to draft for their fantasy baseball team.",
    skills: ["Elixir", "Swift", "Phoenix"],
  },
  {
    href: "https://github.com/jordengerovac/the-rush-challenge",
    image: rush,
    alt: "The Rush challenge dashboard",
    title: '"The Rush" Challenge',
    description:
      "The goal of this coding challenge was to build a scalable app that allows users to upload spreadsheet data containing NFL players and their rushing stats, and then view the uploaded data in a customizable table. Built using the MERN stack.",
    skills: ["JavaScript", "React", "Node", "Express", "MongoDB"],
  },
  {
    href: "https://github.com/jordengerovac/algorithm-visualizations",
    image: algorithms,
    alt: "A-star algorithm visualization",
    title: "Algorithm Visualizations",
    description:
      "Visualizations of a few different algorithms using Python and Tkinter.",
    skills: ["Python"],
  },
];

function Projects() {
  return (
    <PageLayout title="Projects" className="projects-page-container">
      <div className="projects-content container">
        <div className="row gx-5">
          {projects.map((project) => (
            <ProjectCard key={project.href} {...project} />
          ))}
        </div>
        <div className="row gx-5 my-4">
          <div className="col-lg-12 fade-in">
            <h5 className="back-home-button">
              <a
                className="partial-underline-sm"
                href="https://github.com/jordengerovac"
                target="_blank"
                rel="noreferrer"
              >
                View all projects <span>&#187;</span>
              </a>
            </h5>
          </div>
        </div>
      </div>
    </PageLayout>
  );
}

export default Projects;
